<era-master-detail flexGrowLeft="2"
                   flexGrowRight="1"
                   [isH2]="false">
  <era-master>
    <era-panel>
      <div class="px-3">
        <era-devices-state-list [stateInput]="state()"></era-devices-state-list>
      </div>
    </era-panel>
  </era-master>
</era-master-detail>